import { render, staticRenderFns } from "./LeaderboardShare.vue?vue&type=template&id=c5883a52&scoped=true"
import script from "./LeaderboardShare.vue?vue&type=script&lang=js"
export * from "./LeaderboardShare.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardShare.vue?vue&type=style&index=0&id=c5883a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5883a52",
  null
  
)

export default component.exports